module.exports = __webpack_public_path__ + "img/kb.d292224.png";